export default "__VITE_ASSET__BaPJ7Xmh__"